export const BOOKING_STATUS = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    CANCELLED: 'cancelled',
    COMPLETED: 'completed',
    NO_SHOW: 'no-show',
};
export const BOOKING_STATUS_VALUES = Object.values(BOOKING_STATUS);
export const BOOKING_TYPE = {
    STANDARD: 'standard',
    LESSON: 'lesson',
    DEMO: 'demo',
    BLOCK: 'block',
};
export const BOOKING_TYPE_VALUES = Object.values(BOOKING_TYPE);
export const BOOKING_SOURCE = {
    ADMIN: 'admin',
    APP: 'app',
    WEB: 'web',
    UNKNOWN: 'unknown',
};
export const BOOKING_SOURCE_VALUES = Object.values(BOOKING_SOURCE);
export const PAYMENT_TYPE = {
    DIRECT: 'direct',
    MEMBERSHIP: 'membership',
    MEMBERSHIP_HYBRID: 'membership_hybrid',
    MEMBERSHIP_CROSS_CLUB: 'membership_cross_club',
    PASS: 'pass',
    PASS_HYBRID: 'pass_hybrid',
    PASS_CROSS_CLUB: 'pass_cross_club',
    TEAM: 'team',
    COMP: 'comp',
    DEMO: 'demo',
    LESSON: 'lesson',
    LESSON_HYBRID: 'lesson_hybrid',
    LESSON_DIRECT: 'lesson_direct',
};
export const PAYMENT_TYPE_VALUES = Object.values(PAYMENT_TYPE);
export const PAYMENT_STATUS = {
    PENDING: 'pending',
    COMPLETED: 'completed',
    FAILED: 'failed',
    REFUNDED: 'refunded',
    NO_COST: 'no_cost',
    RETURNED: 'returned',
};
export const PAYMENT_STATUS_VALUES = Object.values(PAYMENT_STATUS);
export const RECURRENCE_PATTERN = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    CUSTOM: 'custom',
};
export const RECURRENCE_PATTERN_VALUES = Object.values(RECURRENCE_PATTERN);
export function isBookingStatus(value) {
    return typeof value === 'string' && BOOKING_STATUS_VALUES.includes(value);
}
export function isBookingType(value) {
    return typeof value === 'string' && BOOKING_TYPE_VALUES.includes(value);
}
export function isBookingSource(value) {
    return typeof value === 'string' && BOOKING_SOURCE_VALUES.includes(value);
}
export function isPaymentType(value) {
    return typeof value === 'string' && PAYMENT_TYPE_VALUES.includes(value);
}
export function isPaymentStatus(value) {
    return typeof value === 'string' && PAYMENT_STATUS_VALUES.includes(value);
}
export function isRecurrencePattern(value) {
    return typeof value === 'string' && RECURRENCE_PATTERN_VALUES.includes(value);
}
export const BLOCK_REASON_MAX_LENGTH = 26;
export const BLOCK_REASON_PRESETS = [
    'Maintenance',
    'Cleaning',
    'Event',
    'Special Booking',
    'Demo',
];
export function normalizeBlockReasonKey(label) {
    const key = label
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
    return key.length > 0 ? key : null;
}
const LEGACY_BLOCK_REASON_LABELS = new Map([
    ['maintenance', 'Maintenance'],
    ['cleaning', 'Cleaning'],
    ['event', 'Event'],
    ['special-booking', 'Special Booking'],
    ['other', 'Other'],
]);
export function resolveBlockReasonFields(raw) {
    const trimmed = typeof raw === 'string' ? raw.trim() : '';
    if (!trimmed)
        return { blockReason: null, blockReasonKey: null };
    const label = LEGACY_BLOCK_REASON_LABELS.get(trimmed) ?? trimmed;
    return { blockReason: label, blockReasonKey: normalizeBlockReasonKey(label) };
}
//# sourceMappingURL=constraints.js.map